import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import type { DocumentEntry } from "./document-entries";
import { DocumentListRow } from "./document-list-row";

/**
 * The period's documents, compact: the files the report reads, in the
 * template's order, then the owner's own numbers when given. A row selects
 * its file; an input with no file offers the upload.
 */
export const DocumentList = ({
  entries,
  selectedId,
  onSelect,
  uploadHref,
  className,
}: {
  entries: DocumentEntry[];
  selectedId: string | null;
  onSelect: (documentId: string) => void;
  /** Absent for someone who only views the template. */
  uploadHref?: (slotKey: string | null) => string | null;
  className?: string;
}) => {
  const groups = [
    {
      label: "Read by the report",
      entries: entries.filter((entry) => entry.role === "input"),
    },
    {
      label: "Your numbers",
      entries: entries.filter((entry) => entry.role === "goal"),
    },
  ].filter((group) => group.entries.length);
  return (
    <nav aria-label="Documents" className={cn("min-w-0", className)}>
      <Stack gap={4} align="stretch">
        {groups.map((group) => (
          <Stack key={group.label} gap={1} align="stretch">
            <Text variant="caption" tone="muted" className="px-2">
              {group.label}
            </Text>
            <Stack render={<ul />} gap={0.5} align="stretch">
              {group.entries.map((entry) => (
                <li key={entry.key}>
                  <DocumentListRow
                    entry={entry}
                    selected={
                      !!entry.document && entry.document.id === selectedId
                    }
                    onSelect={onSelect}
                    uploadHref={uploadHref?.(entry.slot?.key ?? null) ?? null}
                    // The owner's numbers are not a slot, and not replaced here.
                    showPurpose={group.label !== "Your numbers"}
                  />
                </li>
              ))}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </nav>
  );
};
